import { Stack } from '@mui/material';
import PageTitle from './PageTitle';
import { useContext } from 'react';
import { AuthContext } from '../Auth/AuthProvider';
import EmailVerificationAlert from '../Auth/EmailVerificationAlert';

interface PageHeaderProps {
  title: string;
  children?: React.ReactNode;
  titleItem?: React.ReactNode;
  screenreaderOnly?: boolean;
}

export default function PageHeader({
  title,
  titleItem,
  children,
  screenreaderOnly = false,
}: Readonly<PageHeaderProps>) {
  const { user } = useContext(AuthContext);

  const emailVerificationRequired = user && !user.email_verified;
  const hiddenTitleWithoutCustomContent =
    screenreaderOnly && !titleItem && !children;
  const marginBottom = hiddenTitleWithoutCustomContent ? 0 : { xs: 3, md: 6 };

  return (
    <Stack
      direction='column'
      useFlexGap
      sx={{
        gap: { xs: 0, md: 1 },
        marginBottom: marginBottom,
      }}
    >
      {emailVerificationRequired && <EmailVerificationAlert />}

      <Stack direction='column'>
        <Stack
          direction='row'
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <PageTitle text={title} screenreaderOnly={screenreaderOnly} />
          {titleItem}
        </Stack>

        {children}
      </Stack>
    </Stack>
  );
}
